<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="項目名稱" prop="projectName">
        <a-input v-model="form.projectName" placeholder="請輸入項目名稱" :disabled="isEdit && form.projectId != undefined"/>
      </a-form-model-item>
      <a-form-model-item label="DIY模塊項目ID" prop="projectId">
        <a-input v-model="form.projectId" placeholder="請輸入DIY模塊項目ID" />
      </a-form-model-item>
      <a-form-model-item label="聯繫人姓名" prop="contactsName">
        <a-input v-model="form.contactsName" placeholder="請輸入聯繫人姓名" :disabled="isEdit && form.projectId != undefined"/>
      </a-form-model-item>
      <a-form-model-item label="聯繫人電話" prop="contactsPhone">
        <a-input v-model="form.contactsPhone" placeholder="請輸入聯繫人電話" :disabled="isEdit && form.projectId != undefined"/>
      </a-form-model-item>
      <a-form-model-item label="數據庫IP" prop="dbIp">
        <a-input v-model="form.dbIp" placeholder="請輸入數據庫IP"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="數據庫端口" prop="dbPort">
        <a-input v-model="form.dbPort" placeholder="請輸入數據庫端口"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="數據庫名稱" prop="databaseName">
        <a-input v-model="form.databaseName" placeholder="請輸入數據庫名稱"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="數據庫用戶名" prop="dbName">
        <a-input v-model="form.dbName" placeholder="請輸入數據庫用戶名"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="數據庫密碼" prop="dbPwd">
        <a-input v-model="form.dbPwd" placeholder="請輸入數據庫密碼"  allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getProject, addProject, updateProject } from '@/api/system/diy'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表單參數
      form: {
        id: undefined,
        projectId: undefined,
        projectName: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        databaseName:undefined,
        dbName: undefined,
        dbPwd: undefined,
        dbIp: undefined,
        dbPort: 0
      },
      open: false,
      isEdit:false,
      rules: {
        projectName: [{ required: true, message: '項目名稱不能為空', trigger: 'blur' }],
        contactsName: [{ required: true, message: '聯繫人姓名不能為空', trigger: 'blur' }],
        contactsPhone: [
          { required: true, message: '聯繫人手機號不能為空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '請輸入正確的手機號碼',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  filters: {
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按鈕
    cancel() {
      this.open = false
      this.reset()
    },
    // 表單重置
    reset() {
      this.form = {
        id: undefined,
        projectId: undefined,
        projectName: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        dbName: undefined,
        dbPwd: undefined,
        dbIp: undefined,
        dbPort: undefined
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按鈕操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加DIY項目信息'
    },
    /** 修改按鈕操作 */
    handleUpdate(row, ids) {
      this.isEdit = true;
      this.reset()
      const id = row ? row.id : ids
      getProject(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改DIY項目信息'
      })
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateProject(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addProject(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
